module.exports = __webpack_public_path__ + "img/electrovalence-jian@2x.b05414ef.png";